module.exports = __webpack_public_path__ + "img/14.d9e94743.jpg";